module.exports = __webpack_public_path__ + "img/button_up_dark.bbfc256a.png";